import styled, { keyframes } from "styled-components";
import { FaLessThan, FaGreaterThan } from "react-icons/fa";

const sliceLeft = keyframes`
    from{
        opacity:0;
        transform:translateX(-100%);
    }to{
        opacity:1;
        transform:translateX(0%);
    }

`;

export const DivHome = styled.div`
    height: calc(100% - 60px);
    overflow: hidden auto;
    padding: 20px;
    user-select: none;
    @media (max-width: 800px) {
        padding: 5px;
    }
`;
export const DivPrincipal = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    padding-bottom: 10px;
    margin: 0 10px;
    > a {
        margin: 20px 0;
    }
    > h1 {
        width: 20vw;
        cursor: pointer;
    }
`;
export const TituloCategoria = styled.h1`
    width: fit-content;
    font-size: 2em;
    font-family: "Ubuntu", Arial, Helvetica, sans-serif;
    padding: 10px;
    border-radius: 6px;
    transition: 0.5s;

    @media (max-width: 900px) {
        font-size: 30px;
        margin: 0 0 10px;
    }
`;
export const DivCategoria = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    position: relative;
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
        height: 7px;
    }
    ::-webkit-scrollbar-track {
        @media (max-width: 900px) {
            background: #f0f2f5;
        }
    }
    ::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 5px;
        @media (max-width: 900px) {
            background: #f0f2f5;
        }
    }
    > div {
        max-width: 300px;
        max-height: 300px;
        margin: 10px 10px;
        @media (max-width: 900px) {
            max-width: 250px;
            max-height: 250px;
            margin: 10px 10px 10px 0;
        }
        > a {
        }
    }
`;
export const DivPost = styled.div`
    > img {
        width: 300px;
        height: 300px;
        cursor: pointer;
        @media (max-width: 900px) {
            width: 250px;
            height: 250px;
        }
    }
    transition: 0.5s;
    :hover {
        transform: scale(1.02);
        transition: 0.5s;
    }
`;
export const IconFaLessThan = styled(FaLessThan)`
    font-size: 30px;
`;
export const IconFaGreaterThan = styled(FaGreaterThan)`
    font-size: ${(props) => (props.minimum ? "20" : "30px")};
`;
export const DivIcon = styled.div`
    margin: 10px 0 !important;
    display: ${(props) => (props.mobile ? "none" : "flex")};
    min-width: 40px;
    justify-content: center;
    align-items: center;
    position: sticky;
    /* background: #0f1415; */
    opacity: ${(props) => (props.show ? "1" : "0")};
    right: ${(props) => (props.activeRight ? 0 : "unset")};
    left: ${(props) => (props.activeLeft ? 0 : "unset")};
    z-index: 5;
    transition: 0.5s;
    cursor: pointer;

    background: rgb(62, 62, 62);
    background: linear-gradient(
        0deg,
        rgba(62, 62, 62, 1) 0%,
        rgba(199, 199, 199, 1) 100%
    );

    > svg {
        color: #fff;
        transition: 0.5s;
    }
    :hover {
        /* background:#0594a5; */
        > svg {
            transform: scale(1.1);
        }
    }
`;

export const DivTitle = styled.div`
    display: flex;
    width: fit-content;
    cursor: pointer;
    :hover {
        > div {
            animation: ${sliceLeft} 1s backwards;
        }
    }
`;

export const SpanSeeAll = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    > span {
        margin: 0 10px 0 0;
        display: ${(props) => (props.showCategory ? "block" : "none")};
        font-weight: 700;
    }
    /* animation:${(props) => (props.show ? sliceLeft : "")} 2s backwards; */
`;
export const DivPopupTakePhone = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    > input {
        min-width: 400px;
        @media (max-width: 800px) {
            min-width: unset;
        }
    }
`;
